var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06667 3.78203L12.5 10.2154L18.9 3.81536C19.0414 3.66489 19.2117 3.54452 19.4007 3.46147C19.5897 3.37841 19.7936 3.33439 20 3.33203C20.442 3.33203 20.866 3.50763 21.1785 3.82019C21.4911 4.13275 21.6667 4.55667 21.6667 4.9987C21.6706 5.20303 21.6326 5.40601 21.5553 5.59517C21.4779 5.78432 21.3627 5.95567 21.2167 6.0987L14.7333 12.4987L21.2167 18.982C21.4914 19.2508 21.6524 19.6147 21.6667 19.9987C21.6667 20.4407 21.4911 20.8646 21.1785 21.1772C20.866 21.4898 20.442 21.6654 20 21.6654C19.7876 21.6742 19.5757 21.6387 19.3777 21.5613C19.1797 21.4838 19 21.366 18.85 21.2154L12.5 14.782L6.08334 21.1987C5.94252 21.3442 5.77428 21.4603 5.58834 21.5404C5.40241 21.6205 5.20245 21.663 5.00001 21.6654C4.55798 21.6654 4.13406 21.4898 3.8215 21.1772C3.50893 20.8646 3.33334 20.4407 3.33334 19.9987C3.32945 19.7944 3.36737 19.5914 3.44475 19.4022C3.52213 19.2131 3.63735 19.0417 3.78334 18.8987L10.2667 12.4987L3.78334 6.01536C3.50865 5.74663 3.34757 5.38272 3.33334 4.9987C3.33334 4.55667 3.50893 4.13275 3.8215 3.82019C4.13406 3.50763 4.55798 3.33203 5.00001 3.33203C5.40001 3.33703 5.78334 3.4987 6.06667 3.78203Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0588a16a3ad14c1fcb0039c79de1e0b6.svg";
export { ForwardRef as ReactComponent };